module.exports = __webpack_public_path__ + "img/task.73d69e2d.png";